import Calendar from 'owa-calendar-cache/lib/store/schema/Calendar';

/**
 * Predicate for checking Calendar value uniqueness based on the calculatedFolderId.
 */
export function checkUniqueCalendar(arr: Calendar[], value: Calendar): boolean {
    return !arr.some(
        arrVal => arrVal && value && arrVal.calculatedFolderId === value.calculatedFolderId
    );
}
